<template>
  <div>
    <!-- {{ code }} -->
    <v-fade-transition>
      <div v-if="localBreadcrumbs && !noBreadcrumbs" class="mt-6 mt-sm-2">
        <v-breadcrumbs :items="localBreadcrumbs" class="pa-0" divider=">">
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item :href="item.href">
              <span v-if="!$vuetify.breakpoint.smAndUp && item.shortText"
                >{{ item.shortText.toUpperCase() }}
              </span>
              <span v-else>{{ item.text.toUpperCase() | truncate(35) }} </span>
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </div>
    </v-fade-transition>
    <v-fade-transition>
      <div v-if="simple">
        <v-card class="mb-4 pa-4" color="#e9f2f5" flat>
          <div :class="$vuetify.breakpoint.smAndUp ? 'text-h5' : 'text-h6'">
            {{ title }}
          </div>
        </v-card>
      </div>
    </v-fade-transition>
    <v-fade-transition>
      <v-card
        v-if="obj"
        class="mb-4 pa-2"
        color="#e9f2f5"
        flat
        style="border: 1px solid #c4d5db"
      >
        <div class="d-flex flex-row flex-wrap justify-space-between">
          <div class="d-flex flex-row align-center">
            <favorite-toggler :codeObj="obj"></favorite-toggler>
            <div v-if="obj.image" style="min-width: 130px; min-height: 50px">
              <v-img
                :src="imgPath + obj.image"
                contain
                class="pr-4"
                max-width="110px"
                max-height="60px"
              />
            </div>
            <div
              :class="$vuetify.breakpoint.smAndUp ? 'text-h5' : 'text-h6'"
              class="mr-2"
            >
              <span v-if="obj.code">{{ obj.code }}</span>
              {{ obj.name }}
            </div>
            <add-alias :code="code" :name="obj.name" v-if="code"></add-alias>
          </div>

          <v-btn
            text
            small
            @click="showNotes = !showNotes"
            color="primary"
            v-if="obj.notes"
            >{{ showNotes ? "Hide" : "Show" }} {{ notesSummary }}
            <v-icon small
              >mdi-chevron-{{ showNotes ? "up" : "down" }}</v-icon
            ></v-btn
          >
        </div>
        <v-card-text v-if="obj.notes" class="pa-0">
          <v-slide-y-transition>
            <notes-formatter
              :notes="obj.notes"
              :sevenChar="sevenChar"
              v-if="showNotes"
            ></notes-formatter>
          </v-slide-y-transition>
        </v-card-text>
      </v-card>
    </v-fade-transition>
    <div v-if="meta && meta.abridged" class="my-2 mx-4 font-italic caption">
      Note: Due to the large number ({{
        meta.counts.hidden + meta.counts.codes
      }}) of items only top-level codes are being displayed. Click a section to
      navigate to more specific <b>(and billable)</b> codes.
    </div>
    <!-- <v-btn icon x-small class="hideIt"
      ><v-icon x-small>mdi-pencil</v-icon></v-btn
    > -->
  </div>
</template>

<script>
import IcdObjectMixin from "@/assets/js/icd/IcdObjectMixin";

export default {
  name: "IcdHeader",
  components: {
    // NotesExpansion: () => import("@/components/icdStuff/NotesExpansion"),
    NotesFormatter: () => import("@/components/icdStuff/NotesFormatter"),
    AddAlias: () => import("@/components/icdStuff/AddAlias"),
    FavoriteToggler: () => import("@/components/icdStuff/FavoriteToggler"),
  },
  mixins: [IcdObjectMixin],
  props: {
    meta: null,
    codes: null,
    title: { type: String, default: null },
    sevenChar: null,
    simple: { type: Boolean, default: false },
    noBreadcrumbs: { type: Boolean, default: false },
  },
  data: function () {
    return {
      showNotes: false,
      // notesSummary: null,
      allChaptersRoute: "CodeChapters",
      imgPath: "https://www.eyedock.com/images",
      allChaptersBreadcrumb: {
        text: "ICD 10 Chapters",
        shortText: "Chapters",
        href: "/icd10/chapters",
      },
    };
  },
  methods: {},
  computed: {
    code: function () {
      return this.obj.code ? this.obj.code : null;
    },
    obj: function () {
      let typeKey = this.meta?.searchObj;
      if (!typeKey) return null;
      // console.log(typeKey);
      return this.icdObjForKey(typeKey); // from IcdObjectMixin
    },
    localTitle: function () {
      let rtn = this.title ? this.title : null;
      return rtn;
    },

    localBreadcrumbs: function () {
      let rtn = [];
      let route = this.$route.name;
      // console.log(route);
      if (route != this.allChaptersRoute) {
        rtn.push(this.allChaptersBreadcrumb);
      }
      if (this.meta?.breadcrumbs) {
        for (let bc of this.meta?.breadcrumbs) {
          // console.log(bc);
          let bcEl = this.icdObjForKey(bc); // from IcdObjectMixin
          // console.log(bcEl);
          if (!bcEl) continue;
          let bcObj = {};
          bcObj.text = bcEl.name;
          if (bcEl.code) {
            bcObj.href = "/icd10/" + bcEl.code;
            bcObj.text += ` (${bcEl.code})`;
          }
          if (bcEl.range) {
            bcObj.href = "/icd10/" + bcEl.range;
            bcObj.shortText = bcEl.range;
          }
          // console.log(bcObj);
          rtn = rtn.concat(bcObj);
        }
      }

      // console.log(rtn);
      return rtn;
    },

    notesSummary: function () {
      let notesObj = this.obj?.notes;
      if (!notesObj) return null;
      // console.log(val);
      let keys = Object.keys(notesObj);
      // console.log("keys", keys);
      let exclusions = 0;
      let inclusions = 0;
      let rtn = "";
      for (const key of keys) {
        // console.log(key);
        let notesRow = notesObj[key];
        if (notesRow && key.includes("incl")) inclusions += notesRow.length;
        if (notesRow && key.includes("excl")) exclusions += notesRow.length;
      }
      if (inclusions > 0) rtn = ` ${inclusions} inclusions`;
      if (inclusions > 0 && exclusions > 0) rtn += " and ";
      if (exclusions > 0) rtn += ` ${exclusions} exclusions`;
      return rtn == "" ? "notes" : rtn;
    },
    // imageForCode: function () {
    //   return this.meta?.images?.[this.code];
    // },
  },
  mounted: function () {
    //this.showNotes = this.$vuetify.breakpoint.smAndUp;
  },
};
</script>

<style scoped>
.titleDiv {
  background-color: #e9f2f5;
  padding: 7px 20px;
  border-radius: 3px;
}
/* .highlight {
  background-color: #fbffc4;
  padding: 4px;
} */
.hideIt {
  float: right;
}
</style>
